export default __webpack_public_path__ + "static/media/phoenixcloak.e95e114c.png";